// src/pages/Dctfweb.jsx
import React, { useEffect, useState, useCallback } from "react";
import api from "../services/api";
import { useAuth } from "../context/AuthContext";

export default function Dctfweb() {
    const { logout } = useAuth();
    const [registros, setRegistros] = useState([]);
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState("");
    const [selecionados, setSelecionados] = useState([]); // << NOVO

    const [filtros, setFiltros] = useState({
        cliente: "",
        competencia: "",
        ativo: "",
        cnpj: "",
        carteira: ""
    });

    const [form, setForm] = useState({
        id: null,
        codigo_emp: "",
        cnpj: "",
        carteira: "",
        cliente: "",
        tipo: "",
        competencia: "",
        codigo: "",
        ativo: "",
    });

    const carregarRegistros = useCallback(async () => {
        try {
            setLoading(true);
            setErro("");

            const params = {};
            if (filtros.cliente) params.cliente = filtros.cliente;
            if (filtros.competencia) params.competencia = filtros.competencia;
            if (filtros.ativo) params.ativo = filtros.ativo;
            if (filtros.cnpj) params.cnpj = filtros.cnpj;
            if (filtros.carteira) params.carteira = filtros.carteira;

            const response = await api.get("/dctfweb", { params });
            setRegistros(response.data);
            setSelecionados([]); // limpa seleção ao filtrar
        } catch (err) {
            console.error(err);
            setErro("Erro ao carregar registros");
        } finally {
            setLoading(false);
        }
    }, [filtros]);

    useEffect(() => {
        carregarRegistros();
    }, [carregarRegistros]);

    // --------------------------
    //         CHECKBOX
    // --------------------------

    function toggleSelecionar(id) {
        setSelecionados((old) =>
            old.includes(id) ? old.filter((i) => i !== id) : [...old, id]
        );
    }

    function selecionarTodos() {
        if (selecionados.length === registros.length) {
            setSelecionados([]);
        } else {
            setSelecionados(registros.map((r) => r.id));
        }
    }

    async function atualizarSelecionados(ativo) {
        if (selecionados.length === 0) {
            alert("Selecione pelo menos 1 registro!");
            return;
        }

        if (!window.confirm(`Atualizar ${selecionados.length} registros para '${ativo}' ?`)) {
            return;
        }

        try {
            await api.put("/dctfweb/lote", {
                ids: selecionados,
                ativo,
            });

            alert("Registros atualizados!");
            carregarRegistros();
        } catch (err) {
            console.error(err);
            alert("Erro ao atualizar selecionados");
        }
    }

    // --------------------------
    // FORMULÁRIO
    // --------------------------

    function handleChangeFiltro(e) {
        const { name, value } = e.target;
        setFiltros((old) => ({ ...old, [name]: value }));
    }

    function handleChangeForm(e) {
        const { name, value } = e.target;
        setForm((old) => ({ ...old, [name]: value }));
    }

    function limparForm() {
        setForm({
            id: null,
            codigo_emp: "",
            cnpj: "",
            carteira: "",
            cliente: "",
            tipo: "",
            competencia: "",
            codigo: "",
            ativo: "",
        });
    }

    async function handleSubmitForm(e) {
        e.preventDefault();
        setErro("");

        const payload = {
            codigo_emp: form.codigo_emp,
            cnpj: form.cnpj,
            carteira: form.carteira,
            cliente: form.cliente,
            tipo: form.tipo,
            competencia: form.competencia,
            codigo: form.codigo,
            ativo: form.ativo,
        };

        try {
            if (form.id) {
                await api.put(`/dctfweb/${form.id}`, payload);
                alert("Registro atualizado com sucesso!");
            } else {
                await api.post("/dctfweb", payload);
                alert("Registro criado com sucesso!");
            }
            limparForm();
            carregarRegistros();
        } catch (err) {
            console.error(err);
            setErro(
                err.response?.data?.erro ||
                err.response?.data?.mensagem ||
                "Erro ao salvar registro"
            );
        }
    }

    function editarRegistro(registro) {
        setForm({
            id: registro.id,
            codigo_emp: registro.codigo_emp || "",
            cnpj: registro.cnpj || "",
            carteira: registro.carteira || "",
            cliente: registro.cliente || "",
            tipo: registro.tipo || "",
            competencia: registro.competencia || "",
            codigo: registro.codigo || "",
            ativo: registro.ativo || "",
        });
    }

    async function deletarRegistro(id) {
        if (!window.confirm("Deseja excluir?")) return;

        try {
            await api.delete(`/dctfweb/${id}`);
            alert("Registro removido!");
            carregarRegistros();
        } catch (err) {
            console.error(err);
            alert("Erro ao excluir registro");
        }
    }

    // --------------------------
    // RENDERIZAÇÃO
    // --------------------------

    return (
        <div className="container">
            <header className="header">
                <h1>DCTFWEB - CRUD</h1>
                <button onClick={logout}>Sair</button>
            </header>

            {/* FILTROS + FORM LADO A LADO */}
            <div className="cards-inline">

                {/* FILTROS */}
                <section className="card">
                    <h2>Filtros</h2>
                    <div className="filters">
                        <input name="cliente" placeholder="Cliente" onChange={handleChangeFiltro} />
                        <input name="competencia" placeholder="Competência" onChange={handleChangeFiltro} />
                        <input name="cnpj" placeholder="CNPJ" onChange={handleChangeFiltro} />
                        <select name="carteira" onChange={handleChangeFiltro}>
                            <option value="">Carteiras (todas)</option>
                            <option value={1}>Carteira 1</option>
                            <option value={2}>Carteira 2</option>
                            <option value={3}>Carteira 3</option>
                            <option value={4}>Carteira 4</option>
                            <option value={5}>Carteira 5</option>
                            <option value={6}>Carteira 6</option>
                            <option value={7}>Carteira 7</option>
                        </select>
                        <select name="ativo" onChange={handleChangeFiltro}>
                            <option value="">Ativo (todos)</option>
                            <option value="ativo">Ativo</option>
                            <option value="inativo">Inativo</option>
                        </select>

                        <button type="submit" onClick={carregarRegistros}>Aplicar filtros</button>
                    </div>
                </section>

                {/* FORM */}
                <section className="card">
                    <h2>{form.id ? "Editar" : "Novo registro"}</h2>

                    <form onSubmit={handleSubmitForm} className="form-grid">
                        <input name="codigo_emp" placeholder="Código emp" value={form.codigo_emp} onChange={handleChangeForm} />
                        <input name="cnpj" placeholder="CNPJ" value={form.cnpj} onChange={handleChangeForm} />
                        <input name="cliente" placeholder="Cliente" value={form.cliente} onChange={handleChangeForm} />
                        <input name="tipo" placeholder="Tipo" value={form.tipo} onChange={handleChangeForm} />
                        <input name="competencia" placeholder="Competência" value={form.competencia} onChange={handleChangeForm} />
                        <input name="codigo" placeholder="Código" value={form.codigo} onChange={handleChangeForm} />

                        <select name="carteira" value={form.carteira} onChange={handleChangeForm} required>
                            <option value="">Carteira</option>
                            <option value={1}>Carteira 1</option>
                            <option value={2}>Carteira 2</option>
                            <option value={3}>Carteira 3</option>
                            <option value={4}>Carteira 4</option>
                            <option value={5}>Carteira 5</option>
                            <option value={6}>Carteira 6</option>
                            <option value={7}>Carteira 7</option>
                        </select>
                        <select name="ativo" value={form.ativo} onChange={handleChangeForm} required>
                            <option value="">Selecione o status</option>
                            <option value="ativo">Ativo</option>
                            <option value="inativo">Inativo</option>
                        </select>

                        {erro && <p className="error">{erro}</p>}

                        <div className="form-actions">
                            <button type="submit">{form.id ? "Atualizar" : "Criar"}</button>
                            {form.id && (
                                <button type="button" onClick={limparForm}>Cancelar</button>
                            )}
                        </div>
                    </form>
                </section>

            </div>

            {/* TABELA */}
            <section className="card">
                <h2>Registros</h2>

                <div className="mass-actions">
                    <button onClick={() => atualizarSelecionados("ativo")}>
                        Marcar SELECIONADOS como ATIVO
                    </button>

                    <button onClick={() => atualizarSelecionados("inativo")}>
                        Marcar SELECIONADOS como INATIVO
                    </button>
                </div>

                {loading ? (
                    <p>Carregando...</p>
                ) : registros.length === 0 ? (
                    <p>Nenhum registro encontrado.</p>
                ) : (
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <input
                                        type="checkbox"
                                        checked={selecionados.length === registros.length && registros.length > 0}
                                        onChange={selecionarTodos}
                                    />
                                </th>
                                <th>Código emp</th>
                                <th>Cliente</th>
                                <th>CNPJ</th>
                                <th>Carteira</th>
                                <th>Competência</th>
                                <th>Ativo</th>
                                <th>Ações</th>
                            </tr>
                        </thead>

                        <tbody>
                            {registros.map((r) => (
                                <tr key={r.id}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={selecionados.includes(r.id)}
                                            onChange={() => toggleSelecionar(r.id)}
                                        />
                                    </td>

                                    <td>{r.codigo_emp}</td>
                                    <td>{r.cliente}</td>
                                    <td>{r.cnpj}</td>
                                    <td>{r.carteira}</td>
                                    <td>{r.competencia}</td>
                                    <td>{r.ativo}</td>

                                    <td className="botoes-acoes">
                                        <button type="submit" onClick={() => editarRegistro(r)}>Editar</button>
                                        <button type="danger" onClick={() => deletarRegistro(r.id)} className="btn-danger">Excluir</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </section>
        </div>
    );
}
